import React from 'react';
import SEO from '../../components/SEO';
import NavExpander from '../../containers/NavExpander';
import NotFound404 from '../../assets/svg/NotFound404';
import Portrait from '../../assets/img/portrait-of-a-man.png';
import styles from './notFound.css';

const NotFound = () => {
  return (
    <div className={styles.page}>
      <SEO title="404 Not Found" description="404" />
      <NavExpander>
        <section className={styles.wrapper}>
          <div className={styles.content}>
            <h1 className={styles.title}>Something's Missing</h1>
            <div className={styles.portraitWrapper}>
              <img
                className={styles.portrait}
                src={Portrait.placeholder}
                srcSet={Portrait.srcSet}
                alt=""
              />
            </div>
            <div className={styles.numbers}>
              <NotFound404 />
            </div>
          </div>
        </section>
      </NavExpander>
    </div>
  );
};

export default NotFound;
